import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'
import { Legacy } from '@/infrastructure/network/Legacy/schema'

export class Login implements APIRequest<Legacy.Auth.authLoginResponse> {
  response: Legacy.Auth.authLoginResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.POST
  params: Legacy.Auth.authLoginRequest
  constructor(params: Legacy.Auth.authLoginRequest) {
    this.params = params
    this.path = '/login'
  }
}

export class Refresh implements APIRequest<Legacy.Auth.authRefreshResponse> {
  response: Legacy.Auth.authRefreshResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = '/refresh'
  }
}

export class Me implements APIRequest<Legacy.Auth.getMeResponse> {
  response: Legacy.Auth.getMeResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = '/me'
  }
}

export class Logout implements APIRequest<Legacy.Auth.autLogoutResponse> {
  response: Legacy.Auth.autLogoutResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor() {
    this.path = '/logout'
  }
}
